import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Resource, ResourceApi } from "@lbsdk/*";

@Injectable({
  providedIn: "root",
})
export class MockResourcesService {
  onResourcesChanged = new BehaviorSubject<Resource[]>([]);

  constructor(private resourceApi: ResourceApi) {}

  async getPlayerHowToPlayImages(): Promise<Resource[]> {
    try {
      const resources = (await this.resourceApi.find({
        where: {
          type: 'howToPlay',
          key: {
            inq: [
              'mockImage1',
              'mockImage2',
              'mockImage3',
              'mockImage4',
              'mockImage5',
              'mockImage6'
            ]
          }
        }
      }).toPromise()) as Resource[];

      this.onResourcesChanged.next(resources || []);
      return resources || [];
    } catch (_) {
      return [];
    }
  }

  async getResourceCashPrize(): Promise<Resource> {
    try {
      const resources = (await this.resourceApi.find({
        where: {
          type: 'icon',
          key: 'cashPrize'
        },
        limit: 1
      }).toPromise()) as Resource[];

      const resource = resources && resources.length > 0 ? resources[0] : null;

      this.onResourcesChanged.next(resource ? [resource] : []);
      return resource || {} as Resource;
    } catch (_) {
      return {} as Resource;
    }
  }

  async getLocationIcon(): Promise<Resource> {
    try {
      const resources = (await this.resourceApi.find({
        where: {
          key: 'result'
        },
        limit: 1
      }).toPromise()) as Resource[];

      return resources && resources.length > 0 ? resources[0] : {} as Resource;
    } catch (_) {
      return {} as Resource;
    }
  }
}
